define('BluePoint.OrderTotalFix.OrderTotalFix',
	[
		'BluePoint.OrderTotalFix.OrderTotalFix.View',
		'BluePoint.OrderTotalFix.Cart',
		'BluePoint.OrderTotalFix.MiniCart',
		'BluePoint.OrderTotalFix.CheckoutContainer',
		'BluePoint.OrderTotalFix.Utils'

	]
	, function (
		OrderTotalFixView,
		CartFix,
		MiniCartFix,
		CheckoutContainer,
		Utils
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var cart = container.getComponent('Cart');
				var checkout = container.getComponent('Checkout');
				var environment = container.getComponent('Environment');

				if (cart) {
					CartFix.mountToApp(container);
					MiniCartFix.mountToApp(container);
				}

				// Checkout
				if (environment && environment.getConfig('currentTouchpoint') === 'checkout') {
					require(['BluePoint.OrderTotalFix.CheckoutOverride'], function (CheckoutFix) {
						if (checkout) {
							MiniCartFix.mountToApp(container);
							CheckoutContainer.container = container;
						}
					});
				}
			}
		};
	});
